import AccountConstants from 'client/util/Constants/AccountConstants';
import ModalEventBus, { ModalEvents } from 'client/components/Modal/ModalEventBus';
import UserLockNoPaymentModal from 'client/Payments/components/UserLockNoPaymentModal/UserLockNoPaymentModal.vue';
import store from 'client/store';

const { accountsReceivable } = AccountConstants;

export class UserLockNoPaymentService {
  constructor(storeModule) {
    this.store = storeModule;

    this.userLockServiceWasAlreadyInit = false;
    this.renderModal = () => {};
    this.modalId = '';
    this.orgId = '';
  }

  static openModalProcess() {
    /*
     * Listener to reopen the UserLockModal if other modal closes.
     * The listener must be closed and re-opened if the Modal Div is deleted from the DOM
     */
    ModalEventBus.$off(ModalEvents.close, UserLockNoPaymentService.openUserLockModal);
    ModalEventBus.$on(ModalEvents.close, UserLockNoPaymentService.openUserLockModal);

    UserLockNoPaymentService.openUserLockModal();
  }

  static openUserLockModal() {
    ModalEventBus.open({
      component: UserLockNoPaymentModal,
      preventCloseOnOverlayClick: true,
    });
  }

  areOrgPaymentsPastDue() {
    const org = this.store.getters['OrganizationsCollection/getItemDetails'](this.orgId);

    return org?.accountsReceivable === accountsReceivable.FROZEN;
  }

  dismissUserLockModal() {
    if (this.unsubscribe) this.unsubscribe();
    document.body.removeEventListener('click', this.handleClicksOutsideTheModalListener, true);
    ModalEventBus.$off(ModalEvents.close, UserLockNoPaymentService.openUserLockModal);
    ModalEventBus.close();
  }

  /*
   * This function is meant to prevent "hacky" users from deleting
   * the modal from the DOM or editing any CSS property like display: none or pointer-events: none.
   * and keep using the app.
   */
  handleClicksOutsideTheModal(event) {
    const modalContainer = document.getElementById(this.modalId);
    const wasClickInsideModal = modalContainer && modalContainer.contains(event.target);

    if (wasClickInsideModal) return;
    event.stopPropagation();
    event.preventDefault();

    if (modalContainer) modalContainer.remove();
    ModalEventBus.$off();
    this.renderModal();
    UserLockNoPaymentService.openModalProcess();
  }

  handleNoPayment() {
    UserLockNoPaymentService.openModalProcess();
    this.handleClicksOutsideTheModalListener = event => this.handleClicksOutsideTheModal(event);
    document.body.addEventListener('click', this.handleClicksOutsideTheModalListener, true);
  }

  initUserLockModalProcess(renderModal, modalId) {
    if (!this.userLockServiceWasAlreadyInit) {
      this.userLockServiceWasAlreadyInit = true;
      this.orgId = this.store.state.SettingsModule.orgId;

      if (this.areOrgPaymentsPastDue()) {
        this.renderModal = renderModal;
        this.modalId = modalId;

        this.handleNoPayment();
        this.listenToChangesInAccountsReceivable();
      }
    }
  }

  /**
   * Listener to launch or dismiss the Modal immediately after accounts
   * receivable status is changed.
   */
  listenToChangesInAccountsReceivable() {
    this.unsubscribe = this.store.subscribe(({ type, payload }) => {
      const { attributes, id } = payload || {};

      const dismissModal = type === 'OrganizationsCollection/SET_ITEM_DETAILS'
        && id === this.orgId
        && attributes?.accountsReceivable !== accountsReceivable.FROZEN;

      if (dismissModal) this.dismissUserLockModal();
    });
  }
}

export default new UserLockNoPaymentService(store);
